import React, { useState,useEffect } from "react";
import { useParams,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import { GetLocalStorageValue,isNull } from "../../components/common/Common";

//원생의 수업을 다른 클래스로 이동
const StudentChildrenMove = () => {
  let { cl_idx } = useParams();
  const navigate = useNavigate();
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  //이동 가능한 클래스목록, 수업차수목록
  const [varClassList,setClassList] = useState([]); 
  const [varClassStudyList,setClassStudyList] = useState([]);
  const [varClassStudyNumberList,setClassStudyNumberList] = useState([]);

  //이동시킬 클래스번호/시작차수/수업수
  const [varClassStudyInfo,setClassStudyInfo] = useState({});

  //이동할 수업에 관한 내역 
  const [varClassInfo,setClassInfo] = useState({});
  const [varMoveStudyList,setMoveStudyList] = useState([]);
  //이동받을 수업에 대한 내역
  const [varAddStudyList,setAddStudyList] = useState([]);
  //새로운 클래스에 존재유무를 통한 원생등록번호
  const [varAddSChildrenIndex,setAddSChildrenIndex] = useState([]);
  
  //수업이동을 위한 정보 호출
  const GetInformationForMoving = async(ch_idx,storageNumb,paymentIndex) => {
    const sendData = {ch_idx:ch_idx,bh_idx:branch_idx,cl_idx:cl_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_information_moving`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const curClasses = datas.curClasses[0];
        let ch_name = "";
        if(datas.childrens.length > 0) ch_name = datas.childrens[0].ch_name;
        setClassInfo({ch_idx:ch_idx,ch_name:ch_name,cl_name:curClasses.cl_name,clc_idx:curClasses.clc_idx,
                      paymentIndex:paymentIndex,storageNum:storageNumb,csArray:[]})

        //동일한 학기내 이동 가능한 모든 클래스 내역
        setClassList(datas.othClasses);
        //이동시킬 수업수 목록 생성
        MakeClassStudyNumberList(storageNumb);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    //수업차수 초기화
    setClassStudyInfo({cl_idx:0,cl_name:"",startNum:0,moveNum:0});

    //이동시킬 수업정보문자를 배열로 변환
    const studyJsonString = GetLocalStorageValue('move_study_information',1);
    let storageNumb = 0;
    let paymentIndex = 0;
    let ch_idx = 0;
    if(!isNull(studyJsonString)) {
      const moveStudyArray = JSON.parse(studyJsonString);
      console.log(moveStudyArray);
      setMoveStudyList(moveStudyArray);
      storageNumb = moveStudyArray.length;
      ch_idx = moveStudyArray[0].ch_idx;
      paymentIndex = moveStudyArray[0].clc_ph_idx;  //클래스 구매번호 - 결제취소시 사용
    }
    //서버로부터 정보 호출
    GetInformationForMoving(ch_idx,storageNumb,paymentIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //정보 변경
  const onChangeSelectHandler = (e) => {
    const { name, value } = e.target;
    const ivalue = Number(value);
    
    if(name === "cl_idx") {
      //시작차수목록 클리어
      setClassStudyInfo({...varClassStudyInfo,[name]:ivalue,startNum:0});
      if(ivalue === 0) setClassStudyList([]);
      else ResetStudysList(ivalue);
    } else if(name === "startNum"){
      setClassStudyInfo({...varClassStudyInfo,startNum:ivalue,moveNum:0});
    } else if(name === "moveNum"){
      const countStudy = varClassStudyInfo.startNum + ivalue - 1;
      
      if( ivalue > varClassInfo.storageNum) {
        alert('이동시킬 수량이 보유수량보다 크므로 작업을 진행할 수 없습니다. 확인수 수량을 재입력하세요.'); return false;
      }
      const imax = varClassStudyList.length-1;
      const maxStudy = varClassStudyList[imax].cs_index;
      if( countStudy > maxStudy) {
        alert('이동시킬 수업의 갯수가 등록할 수업차수보다 큰 수업이 있습니다. 확인수 수량을 재입력하세요.'); return false;
      }
      setClassStudyInfo({...varClassStudyInfo,moveNum:ivalue});
    } 
  }

  //수업차수배열 생성
  const ResetStudysList = async(cl_idx) => {
    const sendData = {cl_idx:cl_idx,ch_idx:varClassInfo.ch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_studys_list_availables`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //선택 가능한 차수 목록
        setClassStudyList(datas.studyList); 
        //이동할 클래스에 원생이 이미 등록되어 있는지
        let clc_idx = 0;
        if(datas.childrens.length > 0) clc_idx = datas.childrens[0].clc_idx;
        setAddSChildrenIndex(clc_idx);
      }
    });
  }

  //이동시킬 수업수 목록 생성
  const MakeClassStudyNumberList = (storageNumb) => {
    //선택 가능한 수업수
    const studyCount =storageNumb;
    let studyList = [];
    for(let i=1; i<=studyCount; i++) {
      studyList.push(i);
    }
    setClassStudyNumberList(studyList);
  }

  //이동할 내역을 임시저장
  const AddMoveStudyHandler = (e) => {
    if(varClassStudyInfo.cl_idx === 0) {
      alert('이동시킬 클래스를를 먼저 선택하세요.'); return false;
    } else if(varClassStudyInfo.statNum === 0) {
      alert('이동시킬 시작수업차수를 먼저 선택하세요.'); return false;
    } else if(varClassStudyInfo.moveNum === 0) {
      alert('이동시킬 끝수업차수를 먼저 선택하세요.'); return false;
    }

    if(varClassStudyInfo.moveNum > varClassInfo.storageNum) {
      alert('이동시킬 수량이 보유수량보다 크므로 작업을 진행할 수 없습니다. 확인수 수량을 재입력하세요.'); return false;
    }
    //결제번호
    const paymentIndex = varClassStudyInfo.paymentIndex;

    //클래스명 추출
    const cl_name = varClassList.find(el=>el.cl_idx===varClassStudyInfo.cl_idx).cl_name;
    const newItem = {...varClassStudyInfo};
    newItem.cl_name = cl_name;
    newItem.clc_idx = varAddSChildrenIndex;

    //클래스의 수업차수별 수업고유번호 추출하여 배열로 저장
    let csArray = [];
    for(let i=0; i<newItem.moveNum; i++) {
      let csIndex = newItem.startNum + i;
      const classStudyData = varClassStudyList.find(el=>el.cs_index === csIndex);
      csArray.push(classStudyData.cs_idx);
    }
    newItem.csArray = csArray;
    console.log(newItem);
    //임시저장 목록에 추가
    setAddStudyList(varAddStudyList.concat(newItem));

    //이동시킬 대상 변수 초기화
    setClassStudyInfo({cl_idx:0,cl_name:"",startNum:0,moveNum:0,clc_idx:0,paymentIndex:paymentIndex,cArray:[]});

    //보유수량에서 공제
    const rem_numb = varClassInfo.storageNum - varClassStudyInfo.moveNum;
    setClassInfo({...varClassInfo,storageNum:rem_numb});
    //이동시킬 수업수 목록 생성
    MakeClassStudyNumberList(rem_numb);
  }

  //수업이동실행
  const ExecuteMoveStudyHandler = async(e) => {
    const sendData = {ch_idx:varClassInfo.ch_idx,paymentIndex:varClassInfo.paymentIndex,clc_idx:varClassInfo.clc_idx,
          delArray:varMoveStudyList,addArray:varAddStudyList};
    console.log(sendData);
    if(!window.confirm('선택된 이동현황에 의해 원생의 수업을 이동시키겠습니까?')) return false;
    await axios.post(`${process.env.REACT_APP_HOST}/branch_execute_moving_studys`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);

      if(datas.retvalue === 1) {
        if(varClassInfo.storageNum === 0) {
          alert('모든 수업의 이동이 완료되었습니다.');
          navigate(`/Branch/StudyChildrenSet/${cl_idx}`);
        } else {
          alert(datas.message);
        }
      } else {
        alert(datas.message);
      }
    });
  }

  return (
    <div className="vh-content center-view-wrap">
      <HeaderBranchTitle varPageTitle={'원생 수업 이동'} varBackString={`/Branch/StudyChildrenSet/${cl_idx}`}/>
      <div className="vh-content-body">
        <div className="view-con st02">
          <div className="center-wrap">
            <div className="con con04" style={{marginTop:"20px",borderRadius:"15px",border:"1px solid #ded3c9"}}>
              <div className="input-line" style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <p style={{fontSize:"13px",color:"#999"}}>원생명</p>
                <div className="field-group" style={{fontSize:"13px"}}>{varClassInfo.ch_name}</div>
              </div>
              <div className="input-line" style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <p style={{fontSize:"13px",color:"#999"}}>이동시킬 클래스명</p>
                <div className="field-group" style={{fontSize:"13px"}}>{varClassInfo.cl_name}</div>
              </div>
              <div className="input-line" style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <p style={{fontSize:"13px",color:"#999"}}>현재 미배정 수업 보유현황</p>
                <div className="field-group" style={{fontSize:"13px"}}>{varClassInfo.storageNum} 수업</div>
              </div>
              <div className={varClassInfo.storageNum===0?"hide":""}>
                <div className="input-line" style={{marginTop:"30px"}}>
                  <p>클래스명</p>
                  <select name="cl_idx" className="field-select" value={varClassStudyInfo.cl_idx} onChange={e=>onChangeSelectHandler(e)}>
                    <option value={0}>클래스선택</option>
                    {varClassList.map((classes,i)=>(
                      <option key={'classes_'+i} value={classes.cl_idx}>{classes.cl_name}</option>
                    ))}
                  </select>
                </div>
                <div className="input-line">
                  <p>시작차수/수업수</p>
                  <div style={{width:"60%",textAlign:"right"}}>
                    <select name="startNum" style={{width:"50%"}} value={varClassStudyInfo.startNum} onChange={e=>onChangeSelectHandler(e)}>
                      <option value={0}>시작차수</option>
                      {varClassStudyList.map((studys,i)=>(
                        <option key={'studys_'+i} value={studys.cs_index}>{studys.cs_index}차수업</option>
                      ))}
                    </select>
                    &nbsp;&nbsp;
                    <select name="moveNum" id="" style={{width:"40%"}} value={varClassStudyInfo.moveNum} onChange={e=>onChangeSelectHandler(e)}>
                      <option value={0}>수업수</option>
                      {varClassStudyNumberList.map((numbs,i)=>(
                        <option key={'numb_'+i} value={numbs}>{numbs}</option>
                      ))}
                    </select>
                  </div>
                </div>			
                <button className="btn-yes" style={{width:"100%",marginTop:"20px"}} onClick={e=>AddMoveStudyHandler(e)}>이동현황으로 등록</button>
              </div>
            </div>
            {/* 이동현황 */}
            <div className="con con04" style={{marginTop:"20px",borderRadius:"15px"}}>
              <div className="con-tit">이동 현황</div>
              <div className="con-box">
                {varAddStudyList.map((moves,i)=>(
                  <div key={'moves_'+i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:"13px",marginBottom:"10px"}}>
                    <p style={{color:"#999",width:"70%"}}>{moves.cl_name}</p>
                    <div>{moves.startNum}차수업부터 {moves.moveNum}개</div>
                  </div>
                ))}
              </div>
              <div className="form-contoller bt-btn">
                <button className="form-contoller-btn btn-yes" style={{marginRight:"0px",width:"100%"}} onClick={e=>ExecuteMoveStudyHandler(e)}>수업 이동 확정하기</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StudentChildrenMove